import { fetchData } from './fetchData';
import { DefaultResponseData } from './data/DefaultResponseData';

export type ResPartnerWriteRequestData = {
    // 帳號(E-mail)
    login: string,
    // id(odoo資料辨識碼)
    id: string,
    // 地址
    contact_address: string,
    // 姓名
    name: string,
    // 電話/手機
    phone: string,
};

function resPartnerWrite(data: ResPartnerWriteRequestData): Promise<DefaultResponseData> {
    return fetchData('api/res_partner_write', {
        method: 'POST',
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((resData: DefaultResponseData) => resData);
}

export { resPartnerWrite };
